export default {
    path: '/educate',
    auth: false,
    preload: false,
    isStatic: true,
    key: 'educate',
    component: () => import('./index')
  };